import React, { useContext } from 'react'
import {OrderSummary} from '@saatva-bits/pattern-library.components.order-summary'
import { staticUrls } from '@/config/globals'
import { CartContext } from '@/store/cart'
import styles from './styles.module.scss'
import { hasFedex, hasWhiteGlove } from '@/utils/order'
import { useExperiment } from '@saatva-bits/pattern-library.modules.launch-darkly'

const OrderSummarySection = () => {
    const { cart } = useContext(CartContext)
    const showWhiteGlove = cart && hasWhiteGlove(cart.items)
    const { isV1: SHOW_DELIVERY_ESTIMATES } = useExperiment('EXP.SHOW_DELIVERY_ESTIMATES.CONV-339')
    const showFedex = cart && hasFedex(cart.items) && (SHOW_DELIVERY_ESTIMATES || !showWhiteGlove)

    return (
        <div className={styles.container}>
            <OrderSummary
                variant="cart"
                cart={cart}
                showWhiteGlove={showWhiteGlove}
                showFedex={showFedex}
                checkoutUrl={staticUrls.checkout}
            />
        </div>
    )
}

export default OrderSummarySection
